import { render } from "./matching-list-desktop.vue?vue&type=template&id=a7c6f164&scoped=true&ts=true"
import script from "./matching-list-desktop.vue?vue&type=script&lang=ts"
export * from "./matching-list-desktop.vue?vue&type=script&lang=ts"

import "./matching-list-desktop.vue?vue&type=style&index=0&id=a7c6f164&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c6f164"]])

export default __exports__